var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.262 1.18055C10.5428 0.939817 10.9573 0.939817 11.2381 1.18055L20.2381 8.89455C20.4764 9.0988 20.5623 9.42984 20.4535 9.7242C20.3446 10.0186 20.0639 10.214 19.75 10.214H19.5V18.93C19.5 19.9352 18.7165 20.75 17.75 20.75H13.75V15.9276C13.75 15.3501 13.5042 14.7962 13.0666 14.3878C12.629 13.9794 12.0356 13.75 11.4167 13.75H10.0833C9.46445 13.75 8.87097 13.9794 8.4334 14.3878C7.99583 14.7962 7.75 15.3501 7.75 15.9276V20.75H3.75C2.7835 20.75 2 19.9352 2 18.93V10.214H1.75004C1.43618 10.214 1.15551 10.0186 1.04662 9.7242C0.93773 9.42984 1.02365 9.0988 1.26195 8.89455L10.262 1.18055Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/home-filled.64f91b8ae183667f708a0c4c52335ce9.svg";
export { ForwardRef as ReactComponent };